module.exports = __webpack_public_path__ + "static/media/benefit-management.47127f7f.svg";